<app-header></app-header>

<div class="container below_header">
    
        <div class="container">
            <div class="row">
               <p class="col-lg-12 col-md-12 col-xs-12 header_txt">Use existing payment method or add new payment method
</p>
            </div>
         </div>

                  <div class="container">
            <div class="row">
               <div class="col-lg-12 col-md-12 col-xs-12 payment_txt">
                  Payment : {{amount | currency}}
               </div>
               <!-- <div class="col-lg-6 col-md-6 col-xs-12 belowpayment_main">
                  <div class="col-lg-7 col-md-7 col-xs-12 existing_act">
                        <p-select [options]="profileDetail" [autoWidth]="false" [style]="{'width':'100%','text-align':'left'}" [(ngModel)]="selectedProfile"
         placeholder="Select Payment Method" name="chaseProfileName" appendTo="body" optionLabel="chaseProfileName" (ngModelChange)="SelectedState(selectedProfile)"></p-select> 
                  </div>
                  
                  <button [disabled]="isPayExistingProfileInProgress" type="button" class="btn make_payment" (click)="PayUsingExistingProfile()" [disabled]="isProfileSubmitDisabled">
                        <span *ngIf="!isPayExistingProfileInProgress">Make Payment</span>
                        <i *ngIf="isPayExistingProfileInProgress" class="fa fa-refresh fa-spin"></i>
                  </button>
                  
               </div> -->
               <div class="col-lg-6 col-md-6 col-xs-12 belowpayment_main d-flex align-items-center gap-2"> 
  
                  <!-- Dropdown column -->
                  <div class="col-lg-8 col-md-8 col-xs-8 existing_act p-0">
                    <p-select 
                      [options]="profileDetail" 
                      [autoWidth]="false" 
                      [style]="{'width':'100%','text-align':'left','margin-top':'10px', 'margin':'-17px','height':'33px'}" 
                      [(ngModel)]="selectedProfile"
                      placeholder="Select Payment Method" 
                      name="chaseProfileName" 
                      appendTo="body" 
                      optionLabel="chaseProfileName" 
                      (ngModelChange)="SelectedState(selectedProfile)">
                      <ng-template pTemplate="selectedItem" let-selectedOption>
                        {{ selectedOption?.chaseProfileName }}
                      </ng-template>
                      <ng-template pTemplate="item" let-option>
                        {{ option.chaseProfileName }}
                      </ng-template>
                    </p-select> 
                  </div>
                
                  <!-- Button column -->
                  <div class="col-lg-4 col-md-4 col-xs-4 p-0" style="width: 144px;">
                    <button 
                      [disabled]="isPayExistingProfileInProgress || isProfileSubmitDisabled" 
                      type="button" 
                      class="btn make_payment w-100" 
                      (click)="PayUsingExistingProfile()">
                      
                      <span *ngIf="!isPayExistingProfileInProgress">Make Payment</span>
                      <i *ngIf="isPayExistingProfileInProgress" class="fa fa-refresh fa-spin"></i>
                    </button>
                  </div>
                
                </div>
                




                <div class="col-lg-6 col-md-6 col-xs-12 note_main">
                  <b>NOTE : </b>
                  <ul>
                        <li>Select your payment method from the menu and click “Make Payment”</li>
                        <li>If you’d like to add an alternate method of payment, click “Add Payment Method  "</li>
                  </ul>
                  
               </div>

               <div class="col-lg-12 col-md-12 col-xs-12">                  
                  <button type="button" (click)="goback()" class="btn goback"><i class="fa fa-angle-left"></i> Back</button>   
              </div> 

            </div>

            <div class="col-lg-5 col-md-5 col-xs-12 line"></div>
            <div class="col-lg-12 col-md-12 col-xs-12 create_actmain">
                  <div class="checkbox">
      <input type="checkbox" [(ngModel)]="createNewProfile" [disabled]="isCreateNewProfileDisabled || isCreateNewProfileCheckboxDisabled" class="checkbox_modified">
      <span class="chk_txt">Save profile information for future payments </span>
    </div>
            </div>

            <div class="col-lg-12 col-md-12 col-xs-12 create_actmain">
            <button type="button" class="btn make_payment" [disabled]="isCreateNewProfileDisabled" (click)="PayUsingNewProfile()">Add Payment Method  <i class="fa fa-plus"></i> </button>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12 cc_main">
               <iframe width="500px" height="500px" [src]="urlSafe" *ngIf="showIframe" frameBorder="0"></iframe>
            </div>
            <!-- <div style="position: right;">
               <span class="col-lg-6 col-md-6 col-xs-12 TransactionAlertMesg" [hidden]="!Transactionmessage">Please do not refresh the page while payment is in progress after submitting.</span>
            </div>   -->
            
         </div>
</div>
